import { OnInit } from '@angular/core';
var FlightCategoryComponent = /** @class */ (function () {
    function FlightCategoryComponent() {
    }
    FlightCategoryComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(FlightCategoryComponent.prototype, "label", {
        /**
         * Returns the flight category label to display to the user
         */
        get: function () {
            return this.flightCategory ? this.flightCategory : '?';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlightCategoryComponent.prototype, "tooltip", {
        /**
         * Returns a tooltip to display to the user when hovering over the flight category
         */
        get: function () {
            return this.flightCategory ? '' : 'Flight category unknown';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlightCategoryComponent.prototype, "cssClass", {
        /**
         * Returns the CSS classes to set on the root element based on flight category
         */
        get: function () {
            return {
                'flight-category--lifr': this.flightCategory === 'LIFR',
                'flight-category--ifr': this.flightCategory === 'IFR',
                'flight-category--mvfr': this.flightCategory === 'MVFR',
                'flight-category--vfr': this.flightCategory === 'VFR'
            };
        },
        enumerable: true,
        configurable: true
    });
    return FlightCategoryComponent;
}());
export { FlightCategoryComponent };
